/*
 * @Author: Src
 * @Date: 2025-06-04 10:44:13
 * @LastEditTime: 2025-06-04 20:04:35
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/customerFunding.service.ts
 * @Description: 头部注释配置模板
 */
import { inject, injectable } from 'inversify';
import HttpClient from './http.service';

@injectable()
export default class CustomerFundingService {
  @inject(HttpClient)
  private http!: HttpClient;

  async getCustomerFundingList(params: any) {
    try {
      const response = await this.http.get('asset/ka/list', { params }) as any;
      return response;
    } catch (error) {
      return null;
    }
  }


  async getCategoryList() {
    try {
      const response = await this.http.get('asset/category') as any;
      return response;
    } catch (error) {
      return null;
    }
  }
  /**
   * 添加跟进
   * @param params
   * @returns
   */
  async postAddFollow(params: any) {
    try {
      const response = await this.http.post('asset/ka/add_follow', params) as any;
      return response;
    } catch (error) {
      return null;
    }
  }

  /**
   * 跟进记录
   * @param params
   * @returns
   */
  async getFollowList(asset_id: any) {
    try {
      const response = await this.http.get(`asset/ka/follows/${asset_id}`) as any;
      return response;
    } catch (error) {
      return null;
    }
  }


  /**
   * 获取部门列表
   * @returns
   */
  async getDeptList() {
    try {
      const response = await this.http.get('asset/agent/dept') as any;
      return response;
    } catch (error) {
      return null;
    }
  }

  /**
   * 获取跟进记录
   * @param asset_id
   * @returns
   */
  async getAgentFollowList(asset_id: any) {
    try {
      const response = await this.http.get(`asset/agent/follows/${asset_id}`) as any;
      return response;
    } catch (error) {
      return null;
    }
  }

  /**
   * 获取KA店铺列表
   * @returns
   */
  async getKaShopList(params: any) {
    try {
      const response = await this.http.get('common/ka_shop', { params }) as any;
      return response;
    } catch (error) {
      return null;
    }
  }

  /**
   * 获取代理列表
   * @param params
   * @returns
   */
  async getAgentList(params: any) {
    try {
      const response = await this.http.get('asset/agent/list', { params }) as any;
      return response;
    } catch (error) {
      return null;
    }
  }
}

